import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getRegulationStageFinanceAttributions: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION]
				.GET_REGULATION_STAGE_FINANCE_ATTRIBUTIONS,
	},

	getRegulationStageFinanceAttribution: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION]
				.GET_REGULATION_STAGE_FINANCE_ATTRIBUTION,
	},

	createRegulationStageFinanceAttribution: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION]
				.CREATE_REGULATION_STAGE_FINANCE_ATTRIBUTION,
	},

	patchRegulationStageFinanceAttribution: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION]
				.PATCH_REGULATION_STAGE_FINANCE_ATTRIBUTION,
	},

	putRegulationStageFinanceAttribution: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION]
				.PUT_REGULATION_STAGE_FINANCE_ATTRIBUTION,
	},

	deleteRegulationStageFinanceAttribution: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.REGULATION_STAGE_FINANCE_ATTRIBUTION]
				.DELETE_REGULATION_STAGE_FINANCE_ATTRIBUTION,
	},
}
